


















































import { Component, Prop, Vue } from "vue-property-decorator";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import * as echarts from "echarts";
const echartsGl = require("echarts-gl");

let x = echartsGl.barometric;

@Component
export default class HelloWorld extends Vue {
  @Prop() private msg!: string;
  file: null | Blob = null;
  selectedChart = "chart3d";
  options = [
    { text: "3D chart", value: "chart3d" },
    { text: "Lines", value: "chartLine" }
  ];

  myChart?: echarts.ECharts;
  map = "";

  mounted() {
    const el = document.getElementById("main");
    if (el) {
      el.style.width = String(0.6 * window.innerWidth) + "px";
      el.style.height = String(0.6 * window.innerHeight) + "px";
      this.myChart = echarts.init(el as HTMLDivElement);
    }
  }
  onFileChange() {
    //    console.log("onFileChange", this);
  }

  onFileInput() {
    //    console.log("onFileInput");
    if (this.file) {
      const fileReader = new FileReader();
      const thisVue = this;
      fileReader.onload = function(event) {
        thisVue.map = (event.target as any).result as string;
        thisVue.drawSparkAdv();
      };
      fileReader.readAsText(this.file);
    }
  }

  onChangeChartType() {
    setTimeout(() => {
      this.initChart();
    }, 50);
  }
    
  onChange(text: string) {
    this.map = text;
  }
  drawSparkAdv() {
    this.initChart("SpkAdv");
  }

  drawInjDur() {
    this.initChart("InjDur");
  }

  drawInjAdv() {
    this.initChart("InjAdv");
  }

  lastChartType? : string;
  lastChartData? : string;

  initChart(which?: string) {
    if (this.lastChartType !== this.selectedChart) {
      this.myChart!.clear();
      this.lastChartType = this.selectedChart;
    }
    if (which === undefined) {
      which = this.lastChartData || "SpkAdv";
    }
    this.lastChartData = which;

    let throttle = "Throttle";
    let rpm = "RPM";
    var data: any[] = [[which, rpm, throttle]];
    //    data = data.concat(this.initMap(which));
    let rpms: number[] = [];
    let max = 0;

    const series: echarts.EChartOption.Series[] = [];
    for (let line of this.map.split("\n")) {
      let words = line.split(/\s+/).filter( (w) => w.length > 0);

      switch (words[0]) {
        case "RPM":
          words.shift();
          rpms = [];
          for (const rpm of words) {
            if (rpm.length > 0)
            rpms.push(Number(rpm));
          }
          break;
        case which: {
          words.shift();
          let throttle = words.shift();
          const sdata: number[] = [];
          for (let rpm = 0; rpm < words.length; rpm++) {
            let n = Number(words[rpm]);
            if (n > max) max = n;
            data.push([n, rpms[rpm], throttle]);
            sdata!.push(n);
          }
          const sLine: echarts.EChartOption.Series = {
            name: "Thr " + String(throttle),
            type: "line",
            data: sdata
          };
          series.push(sLine);
          break;
        }
        default:
          break;
      }
    }
    let option: echarts.EChartOption;
    // specify chart configuration item and data
    if (this.selectedChart === "chart3d") {
      option = {
        grid3D: {},
        tooltip: {},
        xAxis3D: {
          type: "category",
          name: throttle
        },
        yAxis3D: {
          type: "category",
          name: rpm
        },
        zAxis3D: {
          name: which
        },
        series: [
          {
            type: "bar3D",
            shading: "lambert",
            encode: {
              x: throttle,
              y: rpm,
              z: which,
              tooltip: [0, 1, 2]
            }
          }
        ]
      };
      (option as any).visualMap = {
          max: max,
          dimension: which
        };
      (option as any).dataset = {
          dimensions: [which, rpm, { name: throttle, type: "ordinal" }],
          source: data
        };

    } else {
      option = {
        title: {
          text: which
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: series.map(sn => (sn as any).name)
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          //            boundaryGap: false,
          data: rpms
        },
        yAxis: {
          type: "value"
        },
        series: series
      };
    }
    // use configuration item and data specified to show chart
    if (this.myChart) this.myChart.setOption(option);
  }
}
